import { SxProps, Theme } from '@mui/material';

export const commonSelectSx: SxProps<Theme> = {
  backgroundColor: 'var(--bg-panel)',
  color: 'var(--text-primary)',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--border-color)',
  },
  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--border-color)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--accent-blue)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--accent-blue)',
  },
  '.MuiSvgIcon-root': {
    color: 'var(--text-secondary)',
  },
  '&.Mui-disabled .MuiSvgIcon-root': {
    color: 'var(--text-secondary)',
    opacity: 0.5,
  },
  '& .MuiSelect-select.Mui-disabled': {
    WebkitTextFillColor: 'var(--text-secondary)',
  },
};
